import React from 'react'

export default function SignAsset (props) {
  return (
    <svg
      width="319"
      height="234"
      viewBox="0 0 319 234"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <rect width="319" height="234" fill="#FFF4AD" />
      <path
        d="M213.546 191.946H82.7954V33.7954H183.95L213.546 63.1152V191.946Z"
        fill="#E2C508"
        stroke="#E2C508"
        strokeWidth="1.59078"
      />
      <g filter="url(#filter0_d_1312_14162)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M204.437 69.1461V202.368H72V42.5679H177.858L204.437 69.1461Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.4111 66.0699H144.1V69.5949H88.4111V66.0699Z"
        fill="#E9EBEC"
      />
      <rect
        x="88.4111"
        y="58.4321"
        width="68.5849"
        height="4.1125"
        fill="#E9EBEC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.4111 85.343H175.168V89.4555H88.4111V85.343Z"
        fill="#E9EBEC"
      />
      <rect
        x="88.4111"
        y="93.4137"
        width="93.2051"
        height="4.1125"
        fill="#E9EBEC"
      />
      <rect
        x="88.4111"
        y="78.0793"
        width="106.101"
        height="3.525"
        fill="#E9EBEC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.1394 116.819H181.759V120.854H88.1394V116.819Z"
        fill="#E9EBEC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.1394 124.889H181.759V128.925H88.1394V124.889Z"
        fill="#E9EBEC"
      />
      <rect
        x="88.4111"
        y="108.748"
        width="68.5849"
        height="4.1125"
        fill="#E9EBEC"
      />
      <rect
        x="88.4111"
        y="144.259"
        width="68.5849"
        height="4.1125"
        fill="#E9EBEC"
      />
      <rect
        x="88.4111"
        y="152.33"
        width="68.5849"
        height="4.1125"
        fill="#E9EBEC"
      />
      <path
        d="M177.725 42.5684L177.725 69.2018L204.358 69.2018L177.725 42.5684Z"
        fill="#B0E4EB"
      />
      <circle cx="91.9396" cy="168.751" r="3.988" fill="#1D1F21" />
      <g clipPath="url(#clip0_1312_14162)">
        <rect
          width="5.03747"
          height="5.03747"
          transform="translate(89.6313 166.232)"
          fill="#1D1F21"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.1406 170.104L94.6688 167.576L93.9547 166.862L91.4265 169.39L90.3456 168.309L89.6314 169.023L90.7123 170.104L90.712 170.105L91.4262 170.819L91.4265 170.819L91.4267 170.819L92.1409 170.105L92.1406 170.104Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter1_d_1312_14162)">
        <rect
          x="286.71"
          y="93.3942"
          width="61.1695"
          height="122.71"
          rx="13.3405"
          transform="rotate(90 286.71 93.3942)"
          fill="#4C5152"
        />
        <rect
          x="286.71"
          y="93.3942"
          width="61.1695"
          height="122.71"
          rx="8.45388"
          transform="rotate(90 286.71 93.3942)"
          fill="#565E62"
        />
        <rect
          x="284.856"
          y="95.6183"
          width="56.7208"
          height="119.003"
          rx="6.10558"
          transform="rotate(90 284.856 95.6183)"
          fill="#B0E4EB"
        />
        <path
          d="M285.227 111.93L285.227 136.398C282.361 136.398 280.037 134.074 280.037 131.208L280.037 117.12C280.037 114.254 282.361 111.93 285.227 111.93Z"
          fill="#565E62"
        />
        <rect
          x="177.978"
          y="95.7465"
          width="95.0331"
          height="49.8688"
          fill="white"
        />
        <line
          x1="186.754"
          y1="125.159"
          x2="259.494"
          y2="125.159"
          stroke="#1D1F21"
          strokeWidth="0.713142"
        />
        <path
          d="M203.661 113.134C208.861 113.134 215.645 106.888 216.963 105.415C218.281 103.943 222.079 98.5946 217.382 100.894C212.684 103.194 202.882 119.71 212.033 119.71C214.409 119.71 215.919 119.429 217.893 117.974C218.14 117.793 220.766 115.356 220.8 115.44C220.834 115.524 221.312 117.493 222.079 118.477C223.314 119.689 224.565 120.121 226.288 120.121C227.195 120.121 228.038 120.024 229.195 118.888C230.121 117.979 230.264 118.255 231.311 118.705C234.063 119.888 239.261 122.026 242.171 120.121"
          stroke="black"
          strokeWidth="1.42628"
          strokeLinecap="square"
        />
      </g>
      <rect
        x="186.917"
        y="131.392"
        width="28.6981"
        height="7.05691"
        rx="3.52846"
        fill="#61C9D7"
      />
      <circle cx="191.137" cy="116.805" r="4.26605" fill="#565E62" />
      <g clipPath="url(#clip1_1312_14162)">
        <rect
          width="5.38869"
          height="5.38869"
          transform="translate(188.669 114.11)"
          fill="#565E62"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.353 118.252L194.058 115.548L193.294 114.784L190.589 117.488L189.433 116.332L188.669 117.096L189.825 118.252L189.825 118.253L190.589 119.017L190.589 119.016L190.589 119.017L191.353 118.253L191.353 118.252Z"
          fill="white"
        />
      </g>
      <line
        x1="88.4473"
        y1="176.821"
        x2="161.188"
        y2="176.821"
        stroke="#1D1F21"
        strokeWidth="0.713142"
      />
      <path
        d="M105.355 164.796C110.554 164.796 117.339 158.55 118.657 157.078C119.974 155.606 123.773 150.257 119.075 152.557C114.378 154.856 104.576 171.372 113.727 171.372C116.103 171.372 117.612 171.091 119.587 169.637C119.833 169.455 122.459 167.018 122.494 167.102C122.528 167.187 123.005 169.155 123.773 170.139C125.007 171.352 126.259 171.783 127.982 171.783C128.889 171.783 129.732 171.686 130.889 170.55C131.814 169.641 131.958 169.918 133.005 170.368C135.757 171.55 140.954 173.689 143.865 171.783"
        stroke="black"
        strokeWidth="1.42628"
        strokeLinecap="square"
      />
      <defs>
        <filter
          id="filter0_d_1312_14162"
          x="60.0691"
          y="33.8186"
          width="156.298"
          height="183.662"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.18157" />
          <feGaussianBlur stdDeviation="5.96544" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1312_14162"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1312_14162"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1312_14162"
          x="152.069"
          y="84.6449"
          width="146.572"
          height="85.0313"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.18157" />
          <feGaussianBlur stdDeviation="5.96544" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1312_14162"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1312_14162"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1312_14162">
          <rect
            width="5.03747"
            height="5.03747"
            fill="white"
            transform="translate(89.6313 166.232)"
          />
        </clipPath>
        <clipPath id="clip1_1312_14162">
          <rect
            width="5.38869"
            height="5.38869"
            fill="white"
            transform="translate(188.669 114.11)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
